export const categories = [
  { id: 1, slug: "mingxing-bagua", name: "明星八卦", icon: "ri-star-line", count: 128 },
  { id: 2, slug: "relian-chigua", name: "热恋吃瓜", icon: "ri-heart-line", count: 96 },
  { id: 3, slug: "fenquan-sibi", name: "饭圈撕逼", icon: "ri-fire-line", count: 87 },
  { id: 4, slug: "zongyi-jumu", name: "综艺剧幕", icon: "ri-tv-line", count: 74 },
  { id: 5, slug: "wanghong-bagua", name: "网红八卦", icon: "ri-user-smile-line", count: 65 },
  { id: 6, slug: "yule-neimu", name: "娱乐内幕", icon: "ri-eye-line", count: 53 },
  { id: 7, slug: "shejiao-reshi", name: "社交热事", icon: "ri-chat-smile-2-line", count: 42 },
  { id: 8, slug: "qita-chigua", name: "其他吃瓜", icon: "ri-more-line", count: 31 },
];